import { render, staticRenderFns } from "./model_62.vue?vue&type=template&id=621ac556&scoped=true"
import script from "./model_62.vue?vue&type=script&lang=js"
export * from "./model_62.vue?vue&type=script&lang=js"
import style0 from "./model_62.vue?vue&type=style&index=0&id=621ac556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621ac556",
  null
  
)

export default component.exports